<div class="ai-presets-page">
  <div class="ai-presets-header">
    <div class="header-left">
      <h1>AI Presets</h1>
      <p>
        Showing page {{ pageNumber }} of {{ totalPages || 1 }} 
        (Total {{ totalCount }} presets)
      </p>
    </div>

    <div class="header-right">
      <button type="button" class="create-btn" (click)="onUploadNewPreset()">
        Upload New Preset
      </button>
    </div>
  </div>

  @if (isLoading) {
    <div class="empty-state">Loading AI presets...</div>
  } @else {
    <div class="ai-presets-table-card">
      <div class="table-scroll">
        <table class="ai-presets-table">
          <thead>
            <tr>
              <th>NAME</th>
              <th>DESCRIPTION</th>
              <th>CATEGORY</th>
              <th>ACTIONS</th>
            </tr>
          </thead>

          <tbody>
            @for (preset of presets; track preset.presetId) {
              <tr>
                <td class="preset-name">{{ preset.name }}</td>
                <td class="truncate-cell">{{ preset.description || '-' }}</td>
                <td>
                  <select 
                    class="status-select" 
                    (change)="onCategoryChange(preset, $event)"
                    [disabled]="updatingPresetId === preset.presetId"
                    style="height: 32px; font-size: 0.8rem; padding: 0 10px; border-radius: 8px; border: 1px solid #dbe2ea; background: #fff;"
                  >
                    @for (cat of activeCategories; track cat.presetCategoryId) {
                      <option [value]="cat.presetCategoryId.toString()" [selected]="cat.presetCategoryId === preset.presetCategoryId">{{ cat.name }}</option>
                    }
                  </select>
                </td>
                <td>
                  <div class="action-buttons">
                    <button
                      type="button"
                      class="icon-action delete"
                      (click)="onDeletePreset(preset)"
                      [disabled]="deletingPresetId === preset.perfectlyClearPresetId"
                      title="Delete"
                    >
                      <img src="/icons/delete.svg" alt="Delete" class="action-icon" />
                    </button>
                  </div>
                </td>
              </tr>
            }
            @if (presets.length === 0) {
              <tr>
                <td colspan="4" class="text-center py-4">No presets found.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      
      <!-- Pagination Controls -->
      <div class="pagination-controls">
        <button 
          type="button" 
          class="btn-pagination" 
          (click)="previousPage()" 
          [disabled]="pageNumber === 1 || isLoading">
          Previous
        </button>
        <span class="page-info">Page {{ pageNumber }} of {{ totalPages || 1 }}</span>
        <button 
          type="button" 
          class="btn-pagination" 
          (click)="nextPage()" 
          [disabled]="pageNumber >= totalPages || isLoading">
          Next
        </button>
      </div>
    </div>
  }
</div>

@if (isDeleteModalOpen()) {
  <div class="modal-overlay" (click)="closeDeleteModal()">
    <div class="delete-modal" (click)="$event.stopPropagation()">
      <div class="delete-modal-header">
        <h3>Delete Preset</h3>
        <button type="button" class="modal-close-btn" (click)="closeDeleteModal()">×</button>
      </div>

      <div class="delete-modal-body">
        <p>
          Are you sure you want to delete
          <strong>{{ deletingPreset?.name }}</strong>?
        </p>
      </div>

      <div class="delete-modal-actions">
        <button type="button" class="delete-cancel-btn" (click)="closeDeleteModal()">Cancel</button>
        <button
          type="button"
          class="delete-confirm-btn"
          (click)="confirmDeletePreset()"
          [disabled]="deletingPresetId !== null"
        >
          {{ deletingPresetId !== null ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
}

@if (isUploadModalOpen()) {
  <div class="modal-overlay" (click)="closeUploadModal()">
    <div class="delete-modal" (click)="$event.stopPropagation()">
      <div class="delete-modal-header">
        <h3>Upload New Preset</h3>
        <button type="button" class="modal-close-btn" (click)="closeUploadModal()">×</button>
      </div>

      <div class="delete-modal-body">
        <div class="form-group">
          <label>Name *</label>
          <input type="text" [(ngModel)]="uploadingPresetName" class="form-control" placeholder="Preset Name" />
        </div>
        <div class="form-group">
          <label>Description</label>
          <input type="text" [(ngModel)]="uploadingPresetDescription" class="form-control" placeholder="Preset Description" />
        </div>
        <div class="form-group">
          <label>Category *</label>
          <select [(ngModel)]="uploadingPresetCategoryId" class="form-control status-select">
            <option [ngValue]="null" disabled>Select a Category</option>
            @for (cat of activeCategories; track cat.presetCategoryId) {
              <option [ngValue]="cat.presetCategoryId">{{ cat.name }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label>File *</label>
          <input type="file" accept=".preset" (change)="onFileSelected($event)" class="form-control file-input" />
        </div>
      </div>

      <div class="delete-modal-actions">
        <button type="button" class="delete-cancel-btn" (click)="closeUploadModal()">Cancel</button>
        <button
          type="button"
          class="delete-confirm-btn upload-confirm-btn"
          (click)="confirmUploadPreset()"
          [disabled]="isUploading || !uploadingPresetName || !uploadingPresetFile || !uploadingPresetCategoryId"
        >
          {{ isUploading ? 'Uploading...' : 'Upload' }}
        </button>
      </div>
    </div>
  </div>
}

@if (errorMessage) {
  <div class="global-error-overlay" (click)="clearError()">
    <div class="error-toast" (click)="$event.stopPropagation()">
      <div class="error-icon">
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <div class="error-content">
        <h3>Something went wrong</h3>
        <p>{{ errorMessage }}</p>
        <div class="error-actions">
          <button type="button" class="btn-error-ok" (click)="clearError()">OK</button>
        </div>
      </div>
      <button type="button" class="close-toast-btn" (click)="clearError()">×</button>
    </div>
  </div>
}
